// store/slices/authSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authService } from '../../services/api/auth.service';
import { LoginCredentials } from '../../types/auth';
import { User,ResponseLogin } from '../../types/user';
import { AuthState } from '../../types/auth';
import { PayloadAction } from '@reduxjs/toolkit';

const initialState: AuthState = {
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  isLoading: false,
  error: null
};

export const login = createAsyncThunk<ResponseLogin, LoginCredentials>(
  'auth/login',
  async ({ email, password }) => {
      const data = await authService.login(email, password);
      localStorage.setItem('user', JSON.stringify(data.user));
      localStorage.setItem('token', data.token);
      return data;
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async () => {
      await authService.logout();
      localStorage.removeItem('user');
  }
);

export const checkAuth = createAsyncThunk<User | null>(
  'auth/check',
  async () => {
      const user = await authService.getCurrentUser();
      if (user) {
          localStorage.setItem('user', JSON.stringify(user));
      }
      return user;
  }
);


const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
      builder
          .addCase(login.pending, (state) => {
              state.isLoading = true;
              state.error = null;
          })
          .addCase(login.fulfilled, (state, action: PayloadAction<ResponseLogin>) => {
              state.user = action.payload.user;
              state.isLoading = false;
              state.error = null;
          })
          .addCase(login.rejected, (state, action) => {
              state.isLoading = false;
              state.error = action.error.message || 'Login failed';
          })
          .addCase(logout.fulfilled, (state) => {
              state.user = null;
              state.error = null;
          })
          .addCase(checkAuth.fulfilled, (state, action: PayloadAction<User | null>) => {
              state.user = action.payload;
              state.error = null;
          });
  }
});

export default authSlice.reducer;